import styled from "styled-components";

export const DownloadButton = styled.button`
    background-color: #fe8418;
    border-radius: 1.25rem;
    padding: 0.5rem 1rem;
    cursor: pointer;

    font-family: Inter, sans-serif !important;
    font-size: 1rem;
    color: #fff;
    transition: filter ease-in-out 0.3s;

    &:hover {
        filter: brightness(0.8);
    }

    @media (max-width: 414px) {
        font-size: 0.8rem;
    }

    @media (max-width: 340px) {
        font-size: 0.7rem;
    }
`;

export const MessageContent = styled.div`
    .message-header {
        margin: 0.5rem 0;
        display: flex;
        align-items: center;

        img {
            margin-right: 0.6875rem;
        }
        p {
            font-size: 1rem;
            line-height: 1.5rem;
        }
    }
`;

export const StatusBox = styled.div`
    background-color: ${({ status }) => (status === "aguardando" ? "#E4A11B" : "#26AB40")};
    font-size: 1rem;
    border-radius: 0.2rem;
    cursor: pointer;

    p {
        color: #fff;
        font-weight: bold;
        padding: 0.2rem 0.5rem;
    }
`;

const Container = styled.div`
    .container {
        max-width: 1380px;
    }

    .cover {
        width: 100%;
        height: 670px;
        font-size: 26px;
        color: white;
        background: url(${(props) => `'${props.cover}'`});
        background-size: cover;
        background-position: center center;
        position: relative;
        border-radius: 8px;
        overflow: hidden;

        &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(180deg, rgba(36, 36, 36, 0) 66.96%, #242424 88.69%);
            opacity: 0.8;
            z-index: 1;
        }

        p {
            text-align: center;
            position: absolute;
            bottom: 50px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 2;
            width: 90%;
            line-height: 2rem;
        }

        /* button{
            display: none;
        } */

        span {
            font-size: 18px;
            display: block;
            margin-top: 7px;
        }

        .cover-buttons {
            display: inline;
            position: absolute;
            top: 8px;
            right: 8px;
        }
    }

    .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 60px;
        margin-bottom: 10px;
        padding: 0px 10px;

        p {
            color: black;
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;

            span {
                font-size: 14px;
                font-weight: normal;
                display: block;
                opacity: 0.6;
                font-weight: 400;
            }
        }

        button {
            margin-left: 15px;
        }
    }

    .documents {
        margin-bottom: 85px;

        a {
            text-decoration: none;
        }

        p {
            color: #858585;
            opacity: 0.8;
            font-size: 26px;
            margin-bottom: 30px;
            text-align: center;
        }

        .files {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
        }

        .box {
            width: 124px;
            height: 188px;
            padding: 33px 21px;
            margin: 0px 6px 12px 6px;
            border-radius: 18px;
            position: relative;

            a {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                z-index: 2;
            }

            .name {
                font-size: 14px;
                line-height: 17px;
                word-wrap: break-word;
                color: white;
            }

            .extension {
                position: absolute;
                bottom: 37px;
                font-size: 30px;
                font-weight: 600;
                color: #fbff21;
            }
        }

        .box:nth-child(1n) {
            background: #f15634;

            .extension {
                color: #fbff21;
            }
        }

        .box:nth-child(3n) {
            background: #ce4253;

            .extension {
                color: #fe8418;
            }
        }

        .box:nth-child(2n) {
            background: #166969;

            .extension {
                color: #fbff21;
            }
        }

        .box:nth-child(4n) {
            background: #9d454f;

            .extension {
                color: #fe8418;
            }
        }
    }

    .gallery {
        margin-bottom: 50px;
        padding: 0px 10px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: flex-start;
        flex-direction: column;

        img {
            border-radius: 8px;
        }
        .gallery-header {
            width: 100%;
            display: flex;
            align-items: center;
            margin: 1rem 0;

            justify-content: space-between;

            .gallery-title {
                display: flex;
                align-items: center;
                justify-content: center;

            }

            p {
                margin-right: 3rem;
                margin-left: 0.5rem;
                font-size: 1.5rem;
            }

            .rate {
                button {
                    width: 100%;
                    display: flex;
                    align-items: center;
                }
                p {
                    font-size: 1rem !important;
                    font-weight: 600;
                    margin: 0 0.2rem;
                }
            }

            @media (max-width: 720px) {
                flex-direction: column;
                justify-content: flex-start;
                align-items: start;

                .rate-content{
                 margin-top: 1rem;
                 }

                p {
                    font-size: 1.3rem;
                    margin: 0;
                    margin-right: 1rem;
                }
            }
        }

        p {
            color: #fe8418;
        }

        .photo,
        .video,
        .tour {
            position: relative;
            display: inline-block;
            overflow: hidden;
            cursor: pointer;
            margin-bottom: 22px;
            flex: 0 1 32%;

            img {
                max-width: 100%;
            }

            button {
                background-color: white;
            }

            &:hover {
                filter: drop-shadow(0px 8px 24px rgba(0, 0, 0, 0.35));
            }
        }

        .photo,
        .tour,
        .video {
            .actions {
                visibility: hidden;
                opacity: 0;
                position: absolute;
                bottom: -50px;
                right: 10px;
                transition: all 0.3s ease-in;
                z-index: 2;
            }

            &:hover {
                .actions {
                    visibility: visible;
                    opacity: 1;
                    bottom: 10px;
                }
            }
        }

        .tour,
        .video {
            .icon {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }

        .tour .icon button {
            font-family: "Inter", sans-serif;
            font-size: 14px;
            font-weight: 500;
        }

        .actions .btn-link {
            height: 40px;
            font-size: 10px;
            font-family: "Inter", sans-serif;
            padding: 0px 15px;
            font-weight: normal;
            border-radius: 20px;
            position: absolute;
            font-weight: 400;
            width: 94px;
            right: 50px;

            &:hover {
                background-color: #ffe6d1;
                color: #fe902f;
            }
        }

        .video {
            width: 100%;

            video {
                width: 100%;
            }
        }
    }

    .masonry-grid {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin-left: -27px;
        width: auto;
    }

    .masonry-grid_column {
        padding-left: 27px;
        background-clip: padding-box;
    }

    .masonry-grid_column > div {
        margin-bottom: 22px;
    }

    @media (max-width: 720px) {
        .gallery {
            margin-bottom: 18px;
        }

        .cover {
            max-height: 550px;
            border-radius: 0;

            p {
                bottom: 96px;
            }

            button {
                display: block;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 22px;
                z-index: 3;
            }
        }

        .photo,
        .tour,
        .video {
            &:hover {
                &::after {
                    content: "";
                    background: linear-gradient(180deg, rgba(36, 36, 36, 0) 42.6%, #242424 68.95%);
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 1;
                }
            }
        }

        .info {
            margin-top: 22px;
        }

        .masonry-grid {
            margin-left: -9px;
        }

        .masonry-grid_column {
            padding-left: 9px;
            background-clip: padding-box;
        }

        .masonry-grid_column > div {
            margin-bottom: 2px !important;
        }
    }
`;

export default Container;
